// extracted by mini-css-extract-plugin
export default {"root":"TierPickerModal_root__DXAUy","title":"TierPickerModal_title__ZNNCJ","tierList":"TierPickerModal_tierList__o2b89","cancel":"TierPickerModal_cancel__XzIe9"};